// @ts-ignore
import colors from '@platform-ui/colors';
const themes = {
  gray: {
    color: colors['textfield-placeholder'],
    background: colors['card-secondary']
  },
  red: {
    color: colors['status-error'],
    background: '#fbe4e3'
  },
  green: {
    color: colors['status-success'],
    background: '#dff3e2'
  },
  blue: {
    color: colors.link,
    background: colors.secondary
  },
  blueFilled: {
    color: '#fff',
    background: colors.link
  },
  yellow: {
    color: colors['text-primary'],
    background: colors.primary
  },
  white: {
    color: colors['textfield-placeholder'],
    background: colors['blank-white']
  },
  attention: {
    color: colors['primary-active'],
    background: '#fff1ab'
  }
};
export default themes;